<template>
  <div class="service">
    <div class="back-button">
      <router-link :to="{ name: 'services' }">
        <icon
          variant="arrow-right"
          color="#3683fb"
          style="transform: scaleX(-1)"
        />
        Всі сервіси
      </router-link>
    </div>
    <b-card>
      <div
        v-if="isLoading"
        class="d-flex align-items-center justify-content-center"
        style="height: 400px"
      >
        <b-spinner variant="warning" size="large"></b-spinner>
      </div>
      <div v-else-if="service.disabled">
        <b-alert show variant="warning" class="text-center py-4">
          <h5 class="mb-0">Послуга тимчасово недоступна</h5>
        </b-alert>
      </div>
      <div v-else>
        <service-external
          v-if="service_type == 'external'"
          :service="service"
        />
        <service-local v-if="service_type == 'local'" :service="service" />
      </div>
    </b-card>
  </div>
</template>

<script>
import serviceExternal from "./service-single-components/service-external.vue";
import serviceLocal from "./service-single-components/service-local.vue";
export default {
  components: { serviceExternal, serviceLocal },
  data() {
    return {
      isLoading: false,
      error: null,
      service_type: "local",
      service: {},
    };
  },
  watch: {
    $route: {
      handler() {
        this.getLocalSerivce();
      },
    },
  },
  methods: {
    async getLocalSerivce() {
      this.isLoading = true;
      var res = await this.$api.get("/frontend/services/local/" + this.$route.params.slug);
      if (res.data.success) {
        this.service = res.data.data;
      }
      this.isLoading = false;
    },
    getExternalService() {
      this.isLoading = true;
      var id = this.$route.params.id;
      fetch(
        "https://stryi-rada.gov.ua/wp-json/wp/v2/smart-service?include[]=" + id
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.service = data[0];
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.error("Сталася помилка");
          this.isLoading = false;
        });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.service_type = "external";
      this.getExternalService();
    } else if (this.$route.params.slug) {
      this.getLocalSerivce();
    } else {
      this.$router.push("services");
    }
  },
};
</script>

<style lang="scss" scoped></style>
